import { z } from 'zod';
import { SanityDocumentSchema, SanitySlugSchema } from '../sanity';
import { EntityType } from '$lib/sanity/types';

export const NewsTopicSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.NewsTopic),
  name: z.string(),
  slug: SanitySlugSchema
});

export type NewsTopic = z.infer<typeof NewsTopicSchema>;
